// extracted by mini-css-extract-plugin
export default {"icon":"RegionIcon_icon__fNY2I"};